module.exports = __webpack_public_path__ + "static/img/5.097b740.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/6/sp/5.png
// module id = n8em
// module chunks = 0